export default __webpack_public_path__ + "static/media/logos.7da2e2d1.png";